import React, { useState, useEffect, useRef } from 'react'
import "./PatientLedger.scss"
import Button from 'react-bootstrap/esm/Button'
import { useHistory } from 'react-router'
import { useLocation } from 'react-router-dom'
import moment from 'moment'
import { getPatientLedgerDetails } from 'core/services/api'
import fileUtils from "fileUtils"
import Toast from "../../../../../../components/Toast"
import DatePicker from "react-datepicker"
import Print from 'components/Print/Print'

function PatientLedger() {
  const [responseObj, setResponse] = useState<any>([])
  const [isSuccess, setIsSuccess] = useState<any>(false)
  const [isFailure, setIsFailure] = useState<any>(false)
  const [datePickerIsOpenStart, toggleDatePickerStart] = useState<any>()
  const [datePickerIsOpenEnd, toggleDatePickerEnd] = useState<any>()
  const [startDate, setStartDate] = useState<any>(null)
  const [endDate, setEndDate] = useState<any>(null)

  const history = useHistory()
  const location = useLocation();
  const componentRef = useRef<any>(null)

  const patientId = location?.pathname?.split('/')[3]

  const m = moment(new Date(), "DD-MM-YYYY")
  const currentDate = `${m.format("DD")}-${m.format("MM")}-${m.format(
    "YYYY"
  )}`

  const getPatientLedgerDetailsGet = async () => {
    try {
      const response = await getPatientLedgerDetails(patientId, startDate, endDate)
      setResponse(response)
    } catch (error) {
      console.error(error)
    }
  }

  const handleDownloadPdf = async () => {
    try {
      const response = await getPatientLedgerDetails(patientId, startDate, endDate, true)
      if (response?.pdfUrl) {
        fileUtils.downloadFileViaUrl(response?.pdfUrl, `Ledger_${responseObj?.patientName}_${responseObj?.patientMocId}_${currentDate}.pdf`)
        setIsSuccess(true)
      } else {
        setIsFailure(true)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    getPatientLedgerDetailsGet()
  }, [patientId, startDate, endDate])

  return (
    <div className="patient-ledger-page">
      {isSuccess ? (
        <Toast
          textMessage={"Patient Ledger Downloaded Successfully"}
          type="success"
          onCloseText={"Close"}
          onClose={() => setIsSuccess(false)}
        />
      ) : isFailure ? (
        <Toast
          textMessage={"Failed to download Patient Ledger"}
          type="error"
          onCloseText={"Close"}
          onClose={() => setIsFailure(false)}
        />
      ) : null}
      <section className='top-container'>
        <div className='Left-element' >
          <div
            className="approval-back-image"
            onClick={() => {
              history.goBack()
            }}
          >
            <img
              src={"../../../../assets/images/back-icon.svg"}
              alt="back button"
              className="image-top-wrapper"
              style={{ height: "39px" }}
            />
          </div>
          <div className='Heading'>Patient Ledger</div>
          <div className="wrapper">
            <div className="security-advance-container">
              <div className="subheading-payment">Security Deposit:</div>
              <div className="subheading-value-pl">
                {responseObj?.patientSecurityDeposit?.toFixed(2)}
              </div>
              <div className="subheading-payment">Advance Payment:</div>
              <div className="subheading-value-pl">
                {responseObj?.patientAdvancePayment?.toFixed(2)}
              </div>
            </div>
          </div>
        </div>
        <div className="Right-Element">
          <div className="bill-pending">
            <Button className="common-button">
              Pending Bills Due-{responseObj?.patientPendingAmount?.toFixed(2)}
            </Button>
          </div>
          <div className='print-download-ledger'>
            <Print
              componentRef={componentRef}
            />
            <img
              title="Download"
              src="../../assets/images/Group990.svg"
              height={"25px"}
              width={"35px"}
              className="cursor-pointer"
              alt="download button"
              onClick={() => handleDownloadPdf()}
            />
          </div>
        </div>
      </section>
      <section className='top-next-container'>
        <div className="wrapper">
          <div className="security-advance-container">
            <div className="subheading-payment">Patient ID:</div>
            <div className="subheading-value-pl">
              {responseObj?.patientMocId}
            </div>
            <div className="subheading-payment">Patient Name:</div>
            <div className="subheading-value-pl">
              {responseObj?.patientName}
            </div>
          </div>
        </div>
        <div className='date-section-pl'>
          <span className='date-heading-pl'>Start Date: </span>
          <div className="current-date-pl">
            <img
              className="vital-date cursor-pointer"
              onClick={() => toggleDatePickerStart(!datePickerIsOpenStart)}
              src="../../assets/images/datepickerIcon.svg"
              alt=""
              height={30}
              width={30}
            />
            {datePickerIsOpenStart && (
              <DatePicker
                selected={null}
                onChange={(date: Date) => { setStartDate(date); toggleDatePickerStart(false); }}
                onClickOutside={() => toggleDatePickerStart(false)}
                maxDate={endDate}
                inline
              />
            )}
            <div className='selected-date start-date-pl'>
              {startDate ?
                moment(startDate)?.format("DD-MM-YYYY")
                : <span className='pl-placeholder'>Start Date</span>}
              {startDate && (
                <span className='close-pl' onClick={() => setStartDate(null)}>
                  <img
                    src="../../../../../../assets/images/close-button.svg"
                    alt="close-button"
                    width={20}
                    height={20}
                  />
                </span>
              )}
            </div>
          </div>
          <span className='date-heading-pl'>End Date: </span>
          <div className="current-date-pl">
            <img
              className="vital-date cursor-pointer"
              onClick={() => toggleDatePickerEnd(!datePickerIsOpenEnd)}
              src="../../assets/images/datepickerIcon.svg"
              alt=""
              height={30}
              width={30}
            />
            {datePickerIsOpenEnd && (
              <DatePicker
                selected={null}
                onChange={(date: Date) => { setEndDate(date); toggleDatePickerEnd(false); }}
                onClickOutside={() => toggleDatePickerEnd(false)}
                minDate={startDate}
                inline
              />
            )}
            <div className='selected-date'>
              {endDate ?
                moment(endDate)?.format("DD-MM-YYYY")
                : <span className='pl-placeholder'> End Date</span>}
              {endDate && (
                <span className='close-pl' onClick={() => setEndDate(null)}>
                  <img
                    src="../../../../../../assets/images/close-button.svg"
                    alt="close-button"
                    width={20}
                    height={20}
                  />
                </span>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className='ledger-main-section' ref={componentRef}>
        <section className='section-wrapper-ledger'>
          <div className='heading-1'>{responseObj?.brandName ? responseObj?.brandName : `Mumbai Oncocare Centre ${responseObj?.currentCenter}`}
          </div>
          <div className='heading-2'>{responseObj?.companyName ? responseObj?.companyName : "Cellcure Cancer Centre Private Limited"}</div>
        </section>

        <section className='section-2-ledger'>
          <div className='subHeading-main-pl'>Patient Name:&nbsp;<span className='subHeading2-main'>{responseObj?.patientName}</span></div>
          <div className='subHeading-main-pl'>Patient ID: &nbsp;<span className='subHeading2-main'> {responseObj?.patientMocId}</span></div>
          <div className='subHeading-main-pl'>Advance Amount:&nbsp; <span className='subHeading2-main'>{responseObj?.patientAdvancePayment?.toFixed(2)}</span>	</div>
          <div className='subHeading-main-pl'>Security Deposit:&nbsp;<span className='subHeading2-main'>{responseObj?.patientSecurityDeposit?.toFixed(2)}{" "}
          </span>
          </div>
          <div className='subHeading-main-pl'>Pending Bills Due:&nbsp;<span className='subHeading2-main'>{responseObj?.patientPendingAmount?.toFixed(2)}{" "}
          </span>
          </div>
        </section>
        <table>
          <thead>
            <tr className='heading-row'>
              <th className='table-header date-width'>Date</th>
              <th className='table-header center-width'>Centre Name</th>
              <th className='table-header invoice-width'>Invoice/Receipt Number</th>
              <th className='table-header wide-width'>Details</th>
              <th className='table-header medium-width'>Category</th>
              <th className='table-header medium-width'>Sub Category</th>
              <th className='table-header type-width'>Type</th>
              <th className='table-header payment-width'>Payment Mode</th>
              <th className='table-header small-width'>{"Debit (INR)"}</th>
              <th className='table-header small-width'>{"Credit (INR)"}</th>
              <th className='table-header cb-width'>{"Closing Balance (INR)"}</th>
            </tr>
          </thead>
          <tbody>
            {responseObj?.patientLedgers && responseObj?.patientLedgers?.length > 0 ? (
              responseObj?.patientLedgers?.map((obj: any) => {
                return (
                  <tr className={obj?.isCancelled ? 'cancel-row' : ''}>
                    <td className='table-body date-width '>{moment(obj?.dateOfTransaction).format("DD-MM-YYYY")}</td>
                    <td className='table-body center-width '>{obj?.centerName}</td>
                    <td className='table-body invoice-width'>{(obj?.transaction?.paymentType === "REFUND" || (obj?.transaction?.creditOrDebit === "DEBIT" && (obj?.transaction?.paymentType === "ADVANCE_PAYMENT" || obj?.transaction?.paymentType === "SECURITY_DEPOSIT"))) ? "-" : (obj?.isNewInvoiceEntry || obj?.isCancelled === true) ? obj?.mocInvoiceId : obj?.mocReceiptId}</td>
                    <td className={obj?.isCancelledInvoiceEntry && !obj?.isCancelled ? 'cancel-row table-body wide-width' : 'table-body wide-width'}>{obj?.transactionDetails}</td>
                    <td className='table-body medium-width '>{obj?.category?.replace(/_/g, ' ')}</td>
                    <td className='table-body medium-width'>{obj?.subCategory}</td>
                    <td className='table-body type-width '>{obj?.isNewInvoiceEntry ?
                      "Invoice" :
                      obj?.transaction?.paymentType === "INVOICE" ?
                        "Payment" :
                        obj?.transaction?.paymentType === "REFUND" ?
                          "Refund" :
                          obj?.transaction?.paymentType === "ADVANCE_PAYMENT" ?
                            "Advance" :
                            obj?.transaction?.paymentType === "SECURITY_DEPOSIT" ?
                              "Security" : ""}
                    </td>
                    <td className='table-body payment-width '>{obj?.transaction?.modeOfPayment ? obj?.transaction?.modeOfPayment : '-'}</td>
                    <td className='table-body small-width'>{obj?.debitAmount?.toFixed(2)}</td>
                    <td className='table-body small-width'>{obj?.creditAmount?.toFixed(2)}</td>
                    <td className='table-body cb-width'>{obj?.closingBalance?.toFixed(2)}</td>
                  </tr>
                )
              }))
              :
              <tr >
                <td colSpan={11} className="no-data-pl">No Data Available</td>
              </tr>
            }
            <tr>
              <td className='table-header date-width'></td>
              <td className='table-header center-width'></td>
              <td className='table-header invoice-width'></td>
              <td className='table-header wide-width'></td>
              <td className='table-header medium-width'></td>
              <td className='table-header medium-width'></td>
              <td className='table-header type-width'></td>
              <td className='table-header payment-width bold-style'>Total:</td>
              <td className='table-header small-width bold-style'>{responseObj?.totalDebitAmount?.toFixed(2)}</td>
              <td className='table-header small-width bold-style'>{responseObj?.totalCreditAmount?.toFixed(2)}</td>
              <td className='table-header cb-width bold-style'>{responseObj?.closingBalance?.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  )
}

export default PatientLedger
